export default "__VITE_ASSET__dd5b6803__"